import React from "react";
import PageIntro from "../components/PageIntro";
import termsAndcondition from "../content/terms_and_conditions.json";

const TermsAndConditions = () => {
  return (
    <>
      <PageIntro
        title={termsAndcondition.title}
        subtitle={termsAndcondition.subtitle}
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6"
      ></PageIntro>
      <section className="bg-ofWhite overflow-hidden pb-8">
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {/* Intro */}
          <div>
            {termsAndcondition.intro.map((text, index) => (
              <p key={index} className="mb-2 text-gray-700">
                {text}
              </p>
            ))}
          </div>

          {/* Documents Referenced */}
          <div>
            <h2 className="text-xl font-semibold mb-3">
              {termsAndcondition.documents_referenced.title}
            </h2>

            <ul className="list-disc pl-6 text-gray-700">
              {termsAndcondition.documents_referenced.items.map(
                (doc, index) => (
                  <li key={index}>{doc}</li>
                )
              )}
            </ul>
          </div>

          {/* Regulatory Compliance */}
          {/* Regulatory Compliance */}
          <div className="">
            <h2 className="text-xl font-semibold mb-2">
              {termsAndcondition.regulatory_compliance.title}
            </h2>

            <p className="text-gray-700 mb-4">
              {termsAndcondition.regulatory_compliance.description}
            </p>

            <div className="space-y-3">
              {termsAndcondition.regulatory_compliance.items.map(
                (item, index) => (
                  <p className="mb-2 text-gray-700" key={index}>
                    {item}
                  </p>
                )
              )}
            </div>
          </div>

          {/* Main Sections */}
          {termsAndcondition.sections.map((section, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-lg p-5 bg-white"
            >
              <h3 className="text-lg font-semibold mb-3">{section.heading}</h3>

              {/* Section Content */}
              {section.content &&
                (section.content.length > 2 ? (
                  <ul className="list-disc pl-6 text-gray-700 space-y-1">
                    {section.content.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <div className="space-y-2">
                    {section.content.map((item, i) => (
                      <p key={i} className="text-gray-700">
                        {item}
                      </p>
                    ))}
                  </div>
                ))}

              {/* Sub Sections */}
              {section.sub_sections && (
                <div className="mt-4 space-y-5">
                  {section.sub_sections.map((sub, i) => (
                    <div
                      key={i}
                      className="border-l-2 border-blue-600 pl-4 space-y-2"
                    >
                      <p className="font-medium text-gray-800">{sub.title}</p>

                      {sub.description && (
                        <p className="text-gray-700 text-sm">
                          {sub.description}
                        </p>
                      )}

                      {/* List items (if exists) */}
                      {sub.items && sub.items.length > 0 && (
                        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
                          {sub.items.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/* Grievance Redressal */}
          <div className="border border-gray-300 rounded-lg p-5 bg-gray-50">
            <h3 className="text-lg font-semibold mb-2">
              {termsAndcondition.grievance_officer.title}
            </h3>

            <p className="text-gray-700 mb-3">
              {termsAndcondition.grievance_officer.description}
            </p>

            <p className="text-gray-700">
              <b className="font-semibold">Email: </b>
              <a
                href={`mailto:${termsAndcondition.grievance_officer.email}`}
                className="text-blue-50 underline font-semibold"
              >
                {termsAndcondition.grievance_officer.email}
              </a>
            </p>

            <div className="mt-3 text-gray-700 text-sm space-y-1">
              <p className="font-semibold">Address :</p>
              <p>{termsAndcondition.grievance_officer.Address.company}</p>
              <p>{termsAndcondition.grievance_officer.Address.street}</p>
              <p>{termsAndcondition.grievance_officer.Address.landmark}</p>
              <p>
                {termsAndcondition.grievance_officer.Address.area},{" "}
                {termsAndcondition.grievance_officer.Address.city} –{" "}
                {termsAndcondition.grievance_officer.Address.pincode}
              </p>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default TermsAndConditions;
